export enum FloorCheckType {
    ADMIN = 'ADMIN', MANAGER = 'MANAGER'
}
